import type {Result, UseCase} from 'framework';
import type {BodyMeasurementsError} from '../../domain/errors';
import type {MetricOverviewItem} from '../../domain/metric-overview-item';
import type {BodyMeasurementsRepository} from '../ports/body-measurements.repository';

export class GetMeasurementsOverview implements UseCase<[], readonly MetricOverviewItem[]> {
  constructor(private readonly repository: BodyMeasurementsRepository) {}

  execute(): Promise<Result<readonly MetricOverviewItem[], BodyMeasurementsError>> {
    return this.repository.getOverview();
  }
}
